import { useParams } from "react-router-dom";

import phenom from "../../../../assets/case_study/phenom.svg";
import goken from "../../../../assets/case_study/goken.svg";
import ikf from "../../../../assets/case_study/ikf.svg";
import monitra from "../../../../assets/case_study/monitra.svg";
import incuspaze from "../../../../assets/case_study/incuspaze.svg";

const CaseStudySection7 = {
  phenom: {
    hr_name: "Jetwala Navajyothi",
    designation: "Head of Talent Acquisition",
    content3:
      "Hirestar.io brought structure, speed, and intelligence to our background verification process. What stood out was their ability to deeply integrate with our systems, provide crystal-clear reports, and support us in real time. The drop in manual work and amber cases has been incredible. This is what modern BGV should look like.",
    icon_1: phenom,
  },
  goken: {
    hr_name: "Sanchi",
    designation: "HR Manager",
    content3:
      "Working with Hirestar.io’s BGV platform has been a game changer for us. It has automated our entire background verification process, making it seamless and efficient. Their client support is one of the best we’ve experienced — the whole team is responsive, helpful, and always ready to support.",
    icon_1: goken,
  },
  ikf: {
    hr_name: "Kalpana",
    designation: "Head of HR & Compliance",
    content3:
      "Hirestar.io brought structure, speed, and intelligence to our background verification process. What stood out was their ability to deeply integrate with our systems, provide crystal-clear reports, and support us in real time. The drop in manual work and amber cases has been incredible. This is what modern BGV should look like.",
    icon_1: ikf,
  },
  monitra: {
    hr_name: "Zeba Parveen",
    designation: "HR Head",
    content3:
      "Hirestar.io helped us solve a problem no one else could — simplifying healthcare verification for diverse, multilingual teams. From license checks to full-body medical screening, everything is now handled in one place. The automation, the transparency, and the team support have been exceptional.",
    icon_1: monitra,
  },
  incuspaze: {
    hr_name: "Uddeshya Jain",
    designation: "Operations Manager",
    content3:
      "What we liked most about Hirestar.io was their ability to digitize and automate processes that we had been manually handling for years. From visitor identity checks to verifying vendors and corporate entities, everything became seamless. Their responsiveness and tech-first approach made a real operational difference.",
    icon_1: incuspaze,
  },
};

export default function PhenomCaseSection7() {
  const { companyName } = useParams();
  const companyData = CaseStudySection7[companyName];

  if (!companyData) {
    return (
      <section className="flex items-center justify-center px-4 py-12">
        <h2 className="text-center text-2xl text-gray-500">
          No testimonial available for this company.
        </h2>
      </section>
    );
  }


  return (
    <section className="flex items-center justify-center px-4 py-12 relative  ">
      <div className="max-w-6xl w-full">
        {/* Heading */}
        <h2 className="text-center text-2xl md:text-3xl font-bold text-[#0E103D] mb-8">
          Client Testimonial
        </h2>

        {/* Testimonial Card */}
        <div className="bg-white shadow-md border border-blue-100 rounded-xl relative overflow-hidden px-8 pt-8">
          {/* Quote Icons */}
          <div className="absolute top-4 left-4 text-blue-400 text-3xl">❝</div>
          <div className="absolute top-4 right-4 text-blue-400 text-3xl">❞</div>

          {/* Content */}
          <div className="p-8">
            <p className="text-gray-600 text-lg text-center leading-relaxed">
              {companyData.content3}
            </p>
          </div>

          {/* Divider + Author Section */}
          <div className="border-t border-blue-100 px-8 py-4 flex items-center justify-center space-x-3">
            {/* Avatar Image */}
            <img
              src={companyData.icon_1}
              alt={companyData.hr_name}
              className="w-10 h-10 rounded-full object-cover"
            />
            <div className="text-left">
              <h4 className="font-semibold text-gray-800">
                {companyData.hr_name}
              </h4>
              <p className="text-blue-600 text-sm font-medium">
                {companyData.designation}
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
